import { render, staticRenderFns } from "./CustomFieldsModal.vue?vue&type=template&id=2ea15f46"
import script from "./CustomFieldsModal.vue?vue&type=script&lang=ts"
export * from "./CustomFieldsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports